import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
// const Roles = lazy(() => import('../../pages/users-management/RolesTable'));
const Users = lazy(() => import('../../pages/users-management/UsersTable'));
const Departments = lazy(() => import('../../pages/users-management/Departments'));

function PagesRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            {/* <Route path={`${path}/roles`} component={Roles} /> */}
            <Route path={`${path}/users`} component={Users} />
            <Route path={`${path}/departments`} component={Departments} />
            <Route path={path}>
                <Redirect to={`${path}/roles`} />
            </Route>
        </Switch>
    );
}

export default PagesRoute;
